
import gql from 'graphql-tag';
import personalAccidentScenariosQuery from '~/apollo/queries/product/personalAccidentScenarios'
import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import paTooltips from '~/apollo/queries/product/tooltips/personalAccidentTooltips';
import commonProductMixins from '~/mixins/commonProductMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';



export default {
  name: 'ProductsHomeListingPage',
  mixins: [commonProductMixins, productPromotionMixins, apolloQuickGuideMixins, productInsuranceNameMixins],

  apollo: {
    $loadingKey: 'loading',
    paScenarios: {
      query: gql`
        ${personalAccidentScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        let tmpComp;
        tmpComp = undefined;

        if (this.filter.insCompValue?.length) {
          tmpComp = this.filter.insCompValue.map((x) => x.value);
          // console.log(tmpComp);
        }
        return {
          insCompCode: tmpComp,
          locale: this.currentLocale,
          sum_assured_from: parseInt(this.filter.sumAssuredValue?.value[0]),
          sum_assured_to: 
            this.filter.sumAssuredValue?.value[1] === 3000000
            ? undefined
            : parseInt(this.filter.sumAssuredValue?.value[1]),
          average_premium_from: parseFloat(this.filter.avgAnnualPremiumValue?.value[0]),
          average_premium_to: 
            this.filter.avgAnnualPremiumValue?.value[1] === 5000
            ? undefined
            : parseFloat(this.filter.avgAnnualPremiumValue?.value[1])
        };
      },
    },

    insuranceCompanies: {
      query: insuranceCompaniesQuery,
      prefetch: true,
      variables() { 
        return {
          show_pa: true,
        };
      },
      update(data) {
        return data.insuranceCompanies.data.map((item) => {
          const translations = item.attributes.insurance_company_translations.data;
          // console.debug(translations);
          const filteredTranslations = this.getFilteredTranslations(translations);
          return {
            value: item.attributes.code,
            text:
              filteredTranslations[0].attributes.name +
              ' | ' +
              filteredTranslations[1].attributes.name,
          };
        });
      },
    },
    paTooltips: {
      query: paTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  data() { 
    return {
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),

      filter: {
        insCompValue: [],

        // occupation value
        occupationValue: {
          value: this.$route.query.occupation ? this.$route.query.occupation: "officeWorker"
        },
        // occupation options
        occupationOptions: [
          { value: 'officeWorker', text: this.$t('products.personal_accident.pd_office_worker')}
        ],

        // sum assured value
        sumAssuredValue: {
          value: [
            this.$route.query.sumassuredfrom ? parseInt(this.$route.query.sumassuredfrom) : 0,
            this.$route.query.sumassuredto ? parseInt(this.$route.query.sumassuredto) : 3000000,
          ],
          text: this.$t('products.personal_accident.pd_sum_assured')
        },
        // sum assured options
        sumAssuredOptions: [
          {
            value: [
              this.$route.query.sumassuredfrom ? parseInt(this.$route.query.sumassuredfrom) : 0,
              this.$route.query.sumassuredto ? parseInt(this.$route.query.sumassuredto) : 3000000,
            ],
            text: this.$t('products.personal_accident.pd_sum_assured')
          }
        ],
        sumAssuredSliderRange: [0, 3000000],

        // average premium value
        avgAnnualPremiumValue: {
          value: [
            this.$route.query.avgpremfrom ? parseInt(this.$route.query.avgpremfrom) : 250,
            this.$route.query.avgpremto ? parseInt(this.$route.query.avgpremto) : 5000,
          ],
          text: this.$t('products.personal_accident.pd_firstYearPremium')
        },
        // average premium options
        avgAnnualPremiumOptions: [
          {
            value: [
              this.$route.query.avgpremfrom ? parseInt(this.$route.query.avgpremfrom) : 250,
              this.$route.query.avgpremto ? parseInt(this.$route.query.avgpremto) : 5000,
            ],
            text: this.$t('products.personal_accident.pd_firstYearPremium'),
          },
        ],
        avgAnnualPremiumSliderRange: [250, 5000],
      },
      perPage: 12,
      currentPage: 1,
      paScenarios: null,
      insuranceCompanies: [],

      sortingData: {
        title: this.$t('products.sort'),
        sortValue: {
          value: this.$route.query.sort ? this.$route.query.sort : 'overall_score',
          text: this.$t('products.personal_accident.pd_overall_score'),
        },
        // sorting
        sortingOptions: [
          { value: 'overall_score', text: this.$t('products.personal_accident.pd_overall_score') },
          { value: 'annual_premium', text: this.$t('products.personal_accident.pd_sorting_firstYear_premium' )},
          { value: 'death_dismemberment_score', text: this.$t('products.personal_accident.pd_death_dismember_score') },
          { value: 'medical_score', text: this.$t('products.personal_accident.pd_medical_score') },
          { value: 'physio_score', text: this.$t('products.personal_accident.pd_physio_score') },
          { value: 'bonesetter_score', text: this.$t('products.personal_accident.pd_chinese_med') },
        ],
      },
    };
  },

  computed: {
    modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
    },
    mainQueryLoading() {
      return this.$apollo.queries.paScenarios.loading;
    },

    resultMessage() {
      if (this.mainQueryLoading) {
        return this.$t('products.personal_accident.pd_result').replace('$num', '{ }');
      } else {
        return this.$t('products.personal_accident.pd_result').replace('$num', this.rows);
      }
    },
    displayProducts() {
      return this.sortedItem?.map((item) => {

        const featureArray = [
          {
            text: '$' + this.$formatPrice(parseInt(item.sum_assured)) + ' ' + this.$t('products.personal_accident.pd_sum_assured'),
            type: 'sum_assured'
          }
        ];
        if (item.is_flexible_sa) {
          featureArray.push(
            {
            text: this.$t('products.personal_accident.pd_flexible_sa'),
            type: 'optional_sum_assured'
            }
          )
        }
      return {
        id: item.scenario_code,
        category: this.category,
        scenarioId: item.scenarioID,
        showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
        showTrending: false,
        showCTA: item.show_cta,

        productLink: this.$extendPath(
          this.$route.path,
          '/' +
            item.scenario_code
        ),
        productName: item.plan_name,
        insuranceCompany: {
          name: item.insurer_name_first + ' | ' + item.insurer_name_second,
          code: item.insurer_code,
          logoSrc: item.insurer_logo?.data?.attributes.url,
          logoAlt: item.insurer_name_first,
        },
        userRating: {
          score: item.overall_star,
          numberOfRatedUser: '0',
        },
        tenlifeScore: {
          score: item.overall_score,
          description: this.$t('products.personal_accident.pd_overall_score'),
          toolTipHtml: this.getTooltipContentByKey('pa_overallScore'),
          // toolTipHtml: this.getOverallScoreTooltip(),
        },
        features: featureArray,
        keyItems: [
          {
            value: this.$formatScore(item.death_dismemberment_score) + ' / 10',
            key: this.$t('products.personal_accident.pd_death_dismember_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('pa_deathDismembermentScore'),
            symbolValue: '',
            originalValue: '',
            isSorted: this.sortingData.sortValue.value === 'death_dismemberment_score'
          },
          {
            value: this.$formatScore(item.medical_score) + ' / 10',
            key: this.$t('products.personal_accident.pd_medical_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('pa_medicalScore'),
            symbolValue: '',
            originalValue: '',
            isSorted: this.sortingData.sortValue.value === 'medical_score'
          },
          {
            value: this.$formatScore(item.physio_score) + ' / 10',
            key: this.$t('products.personal_accident.pd_physio_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('pa_physioScore'),
            symbolValue: '',
            originalValue: '',
            isSorted: this.sortingData.sortValue.value === 'physio_score'
          },
          {
            value: this.$formatScore(item.bonesetter_score) + ' / 10',
            key: this.$t('products.personal_accident.pd_chinese_med'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('pa_bonesetterScore'),
            symbolValue: '',
            originalValue: '',
            isSorted: this.sortingData.sortValue.value === 'bonesetter_score'
          },
        ],
        mobileKeyItems: [
          {
            value: this.$formatScore(item.death_dismemberment_score) + ' / 10',
            key: this.$t('products.personal_accident.pd_death_dismember_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('pa_deathDismembermentScore'),
            symbolValue: '',
            originalValue: '',
            isSorted: this.sortingData.sortValue.value === 'death_dismemberment_score',
            isTextBlack: true
          },
          {
            value: this.$formatScore(item.medical_score) + ' / 10',
            key: this.$t('products.personal_accident.pd_medical_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('pa_medicalScore'),
            symbolValue: '',
            originalValue: '',
            isSorted: this.sortingData.sortValue.value === 'medical_score',
            isTextBlack: true
          },
          {
            value: this.$formatScore(item.physio_score) + ' / 10',
            key: this.$t('products.personal_accident.pd_physio_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('pa_physioScore'),
            symbolValue: '',
            originalValue: '',
            isSorted: this.sortingData.sortValue.value === 'physio_score',
            isTextBlack: true
          },
          {
            value: this.$formatScore(item.bonesetter_score) + ' / 10',
            key: this.$t('products.personal_accident.pd_chinese_med'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('pa_bonesetterScore'),
            symbolValue: '',
            originalValue: '',
            isSorted: this.sortingData.sortValue.value === 'bonesetter_score',
            isTextBlack: true
          },
        ],
        compactKeyItems: [
          // {
          //   value: item.promotion_prices[0]
          //     ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
          //     : this.$formatPrice(item.annual_premium),
          //   key: this.$t('products.personal_accident.pd_firstYearPremium'),
          //   topSubText: 'HKD',
          //   toolTipHtml: this.getTooltipContentByKey('pa_adult'),
          //   symbolValue: '',
          //   originalValue: '',
          //   isTextBold: true,
          // },
        ],
        promotion: {
          category:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
          title:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
          ctaButtonLink:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
          ctaButtonText:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
          promotionId: item.product_promotion?.id,
          scenarioId: item.scenarioID,
          hide: item.hide,
          noPopup: item.noPopup,
          lastCall: item.promotion_last_call

        },

        mainButtonCTA: item.main_cta,

        price: {
          originalPrice: item.promotion_prices[0] ? this.$formatPrice(item.annual_premium) : '',
          discountPrice: item.promotion_prices[0]
            ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
            : this.$formatPrice(item.annual_premium),
          prefix: 'HKD',
          postfix: '',
          subText: this.$t('products.personal_accident.pd_firstYearPremium'),
          toolTipHtml: this.getTooltipContentByKey('pa_adult'),
          isSorted: this.sortingData.sortValue.value === 'annual_premium'
        },
      }

      });
    },

    rows() {
      if (this.simpleItems) {
        return this.simpleItems.length;
      }
      return null;
    },

    sortedItem() {
      if (this.sortingData.sortValue.value === 'overall_score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
                const aPrem = a.promotion_prices[0]?a.promotion_prices[0]:a.annual_premium;
                const bPrem = b.promotion_prices[0]?b.promotion_prices[0]:b.annual_premium;
              return (
                b.overall_score_fixed - a.overall_score_fixed ||
                a.annual_premium - b.annual_premium ||
                b.death_dismemberment_score - a.death_dismemberment_score ||
                b.medical_score - a.medical_score ||
                b.physio_score - a.physio_score ||
                b.bonesetter_score - a.bonesetter_score ||
                aPrem - bPrem
              );
            });
        }
      } else if (this.sortingData.sortValue.value === 'annual_premium') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aPrem = a.promotion_prices[0]?a.promotion_prices[0]:a.annual_premium;
              const bPrem = b.promotion_prices[0]?b.promotion_prices[0]:b.annual_premium;
              return (
                a.annual_premium - b.annual_premium ||
                b.overall_score_fixed - a.overall_score_fixed ||
                b.death_dismemberment_score - a.death_dismemberment_score ||
                b.medical_score - a.medical_score ||
                b.physio_score - a.physio_score ||
                b.bonesetter_score - a.bonesetter_score ||
                aPrem - bPrem
              );
            });
        }
      } else if (this.sortingData.sortValue.value === 'death_dismemberment_score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aPrem = a.promotion_prices[0]?a.promotion_prices[0]:a.annual_premium;
              const bPrem = b.promotion_prices[0]?b.promotion_prices[0]:b.annual_premium;
              return (
                b.death_dismemberment_score - a.death_dismemberment_score ||
                b.overall_score_fixed - a.overall_score_fixed ||
                a.annual_premium - b.annual_premium ||
                b.medical_score - a.medical_score ||
                b.physio_score - a.physio_score ||
                b.bonesetter_score - a.bonesetter_score ||
                aPrem - bPrem
              );
            });
        }
      } else if (this.sortingData.sortValue.value === 'medical_score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aPrem = a.promotion_prices[0]?a.promotion_prices[0]:a.annual_premium;
              const bPrem = b.promotion_prices[0]?b.promotion_prices[0]:b.annual_premium;
              return (
                b.medical_score - a.medical_score ||
                b.overall_score_fixed - a.overall_score_fixed ||
                a.annual_premium - b.annual_premium ||
                b.death_dismemberment_score - a.death_dismemberment_score ||
                b.physio_score - a.physio_score ||
                b.bonesetter_score - a.bonesetter_score ||
                aPrem - bPrem
              );
            });
        }
      } else if (this.sortingData.sortValue.value === 'physio_score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aPrem = a.promotion_prices[0]?a.promotion_prices[0]:a.annual_premium;
              const bPrem = b.promotion_prices[0]?b.promotion_prices[0]:b.annual_premium;
              return (
                b.physio_score - a.physio_score ||
                b.overall_score_fixed - a.overall_score_fixed ||
                a.annual_premium - b.annual_premium ||
                b.death_dismemberment_score - a.death_dismemberment_score ||
                b.medical_score - a.medical_score ||
                b.bonesetter_score - a.bonesetter_score ||
                aPrem - bPrem
              );
            });
        }
      } else if (this.sortingData.sortValue.value === 'bonesetter_score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aPrem = a.promotion_prices[0]?a.promotion_prices[0]:a.annual_premium;
              const bPrem = b.promotion_prices[0]?b.promotion_prices[0]:b.annual_premium;
              return (
                b.bonesetter_score - a.bonesetter_score ||
                b.overall_score_fixed - a.overall_score_fixed ||
                a.annual_premium - b.annual_premium ||
                b.death_dismemberment_score - a.death_dismemberment_score ||
                b.medical_score - a.medical_score ||
                b.physio_score - a.physio_score ||
                aPrem - bPrem
              );
            });
        }}
      return null;
    },

    simpleItems() {
      if (this.paScenarios) {
        return this.paScenarios.data.map((item) => {
          // console.log("#######ITEM#######")
          // console.log(item);
          // const decoderCTALink = '';
          let promotionPrices = Array;
          promotionPrices = [];

          let promotions = null;
          let promotion = null;
          let promotion_last_call = null;

          let decoderCTALink = '';
          let decoderCTAText = '';
          let hide = Boolean;
          hide = false;
          let noPopup = Boolean;
          noPopup = false;
          let mainCTA = this.getDecoderCTA(item, decoderCTALink);

          // check scenario level promo first , then plan level promotion 
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.pa_plans.data[0].attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.pa_plans.data[0].attributes.product_promotions.data;
          }
          
          if(promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            if (!promotion) {
              promotion = null;
            } else {
              if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                  decoderCTALink =
                    promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                  decoderCTAText = this.$t('products.product_website');

                  mainCTA = this.getDecoderCTA(item, decoderCTALink)
              }

              promotion_last_call = this.checkPromotionLastCall(promotion);

              const discounts = promotion.attributes.DiscountPercentage;
              if (discounts) {
                // calculate promotion price for annual premium
                // console.log('######IN DISCOUNT#######');
                const annualPremium = item.attributes.pa_premiums.data[0].attributes.annual_premium;

                if (discounts.Year1 === 0) {
                  promotionPrices[0] = null;
                } else {
                  const calculatedPrice = (annualPremium * (100 - discounts.Year1)) / 100;
                  promotionPrices[0] = parseInt(calculatedPrice.toFixed(0));
                }
              }

              const translation = promotion.attributes.product_promotion_translations?.data[0];
              hide = translation?.attributes?.HideBanner;
              noPopup = translation?.attributes?.NoPopup??false;
            }
          }

          const filteredTranslations = this.getFilteredTranslations(item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);

          return {
            scenario_code: item.attributes.scenario_code,
            plan_code: item.attributes.plan_code,
            annual_premium: item.attributes.pa_premiums.data[0].attributes.annual_premium,
            overall_score: item.attributes.overall_score,
            overall_score_fixed: item.attributes.overall_score.toFixed(1),
            death_dismemberment_score: item.attributes.death_dismemberment_score.toFixed(1),
            medical_score: item.attributes.medical_score.toFixed(1),
            physio_score: item.attributes.physio_score.toFixed(1),
            bonesetter_score: item.attributes.bonesetter_score.toFixed(1),
            sum_assured: item.attributes.sum_assured,
            overall_star: item.attributes?.overall_star,
            is_flexible_sa: item.attributes.pa_plans.data[0].attributes.flexible_sa,
            show_cta: item.attributes.show_cta,

            // plan
            plan_name: item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0].attributes.name,

            // product_website:
            //   item.attributes.home_plan.data.attributes.home_plan_translations.data[0].attributes.product_website,

            // insurer
            insurer_name_first:
              item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes.logo,
            insurer_code:
              item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes.code,

            product_promotion: promotion,
            promotion_prices: promotionPrices,
            promotion_last_call: promotion_last_call,

            // discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
            // cta_button_link: CTAButtonLink,
            // cta_button_text: CTAButtonText,

            main_cta: mainCTA,

            scenarioID: item.id,
            hide,
            noPopup,
          };
        });
      }
      return null;
    },
    slug() {
      return 'personal-accident';
    },
    selectedSortingLogic() {
      return this.sortingData.sortValue.value
    },
  },

  created() {
    const filterValuesToWatch = [
      {
        filterValuePath: 'filter.occupationValue',
        filterOptionsPath: 'filter.occupationOptions',
        queryKey: 'occupation',
        defaultValue: 'occupation',
      },
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingData.sortingOptions',
        queryKey: 'sort',
        defaultValue: 'overall_score',
      },
      {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array',
      },
      {
        filterValuePath: 'filter.sumAssuredValue.value[0]',
        queryKey: 'sumassuredfrom',
        defaultValue: 0,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.sumAssuredValue.value[1]',
        queryKey: 'sumassuredto',
        defaultValue: 3000000,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.avgAnnualPremiumValue.value[0]',
        queryKey: 'avgpremfrom',
        defaultValue: 250,
        ignoreFix: true,
        type: 'slider',
      },   {
        filterValuePath: 'filter.avgAnnualPremiumValue.value[1]',
        queryKey: 'avgpremto',
        defaultValue: 5000,
        ignoreFix: true,
        type: 'slider',
      }
    ];

    this.createFilterWatchers(filterValuesToWatch);
    this.fixFilterValues(filterValuesToWatch);
  },

  mounted() {
    const filterArrayValueToFix = {
      filterValuePath: 'filter.insCompValue',
      filterOptionsPath: 'insuranceCompanies',
      queryKey: 'ins_comp[]',
    };

    this.fixFilterArrayValueDueToQueryString(filterArrayValueToFix);
  },

  methods: {

    getDecoderCTA(item, promotionCTALink) {
      const planName = item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.personal_accident.pd_categoryName'), insurer, planName);
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.pa_plans.data.attributes?.saleable;
      const productWebsite =
        item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0].attributes?.product_website;

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link:
            process.env.SALES_EXTERNAL_URL +
            '/' +
            (this.currentLocale === 'en' ? 'en' : 'tc') +
            '/purchase?id=' +
            item.attributes.scenario_code
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.purchase_now'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },

    getTooltipContentByKey(mKey) {
      return this.paTooltips?.PersonalAccident?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getOverallScoreTooltip() {
      const tooltip = this.getTooltipContentByKey('hm_overallScore');
      let replaceHomeContentsScore = '';
      let replaceLiabilityScore = '';
      let replacePersonalAccidentScore = '';

      switch (this.filter.ownerTypeValue.value) {
        case 'T':
          replaceHomeContentsScore = '65%';
          replaceLiabilityScore = '20%';
          replacePersonalAccidentScore = '15%';
          break;
        case 'L':
          replaceHomeContentsScore = '15%';
          replaceLiabilityScore = '80%';
          replacePersonalAccidentScore = '5%';
          break;
        default:
          replaceHomeContentsScore = '50%';
          replaceLiabilityScore = '40%';
          replacePersonalAccidentScore = '10%';
          break;
      }

      return tooltip
        .replace('{replace_home_contents_score}', replaceHomeContentsScore)
        .replace('{replace_liability_score}', replaceLiabilityScore)
        .replace('{replace_personal_accident_score}', replacePersonalAccidentScore);
    },
  },
  components: {
    QuickGuideWrapper
  }
};
